import React, {useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import EquipsRegistryTable from '../../tables/equipTables/EquipRegistryTable'

import { AllEquipsContext } from '../../../context/allEquips-context';
import { CurrentEquipContext } from '../../../context/currentEquip-context';

const useStyles = makeStyles((theme) => ({
  root: {
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width:'100%',
    marginBottom:'1em'
  }
}));


export default function EquipsRegistryTabPanel(props) {
  console.log("render EquipsRegistryTabPanel");

  const classes = useStyles();
  const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);

  return (
    <div className={classes.root}>
      <EquipsRegistryTable data={allEquipsState.registry} equipInfo={currEquipState.equipInfo}/>
    </div>
  );
}